const crypto = require("crypto");
const algorithm = "aes-256-ctr";
const secretKey = "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3";
const iv = "80e2af0a60ecbd16618abc72c2d00fb3";

// encrypt url parameter
export const apsisEncrypt = (url) => {
  const cipher = crypto.createCipheriv(
    algorithm,
    secretKey,
    Buffer.from(iv, "hex")
  );

  const encrypted = Buffer.concat([cipher.update(String(url)), cipher.final()]);

  return encrypted.toString("hex");
};

// Helper function to check if a string is valid hex
const isValidHex = (str) => {
  if (!str || typeof str !== 'string') {
    return false;
  }
  // Remove any whitespace
  const hex = str.trim();
  // Check if it's a valid hex string (even length, only hex characters)
  return /^[0-9a-fA-F]+$/.test(hex) && hex.length % 2 === 0;
};

// decrypt url paramter
export const apsisDecrypt = (url) => {
  // Validate input
  if (!url) {
    throw new Error("Invalid input: URL parameter is empty or undefined");
  }

  const urlString = String(url).trim();
  
  // Check if it's a valid hex string
  if (!isValidHex(urlString)) {
    throw new Error(`Invalid hex string: "${urlString}" is not a valid hexadecimal string`);
  }

  try {
    const decipher = crypto.createDecipheriv(
      algorithm,
      secretKey,
      Buffer.from(iv, "hex")
    );

    const decrpyted = Buffer.concat([
      decipher.update(Buffer.from(urlString, "hex")),
      decipher.final(),
    ]);

    return decrpyted.toString();
  } catch (error) {
    throw new Error(`Decryption failed: ${error.message}`);
  }
};
